<template>
    <custom-popup v-model="valueComputed" :cons="cons" hide-overlay hide-confirm transition="dialog-top-transition"
                  @close="valueComputed = $event" max-width="800px" reloadable>
        <increase-transactions/>
    </custom-popup>
</template>

<script>
import IncreaseTransactions from "./increaseTransactions";
import {mapActions} from "vuex";
import CustomPopup from "@/core/plugins/TitleRibbon/plugins/popup/customPopup.vue";

export default {
    name: "wallet",
    components: {CustomPopup, IncreaseTransactions},
    props: {
        value: Boolean
    },
    data: () => ({
        cons: {
            title: 'شارژ کیف پول جدید'
        }
    }),
    computed: {
        valueComputed: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    }
}
</script>

<style scoped>

</style>
